<template>
	<div class="llogin" @click="closegroup">
		<div class="login">
			<p class="text-right padding pointer"><i class="el-icon-error text-white  icon"></i></p>
			<div class="add bg-white" @click.stop="">
				<p class="text-lg text-left">
					若想添加 <span class="text-theme">蓝友用工官方微信</span> 邀你入群，需要您在手机微信内 <span class="text-theme">添加朋友-搜索框</span> 中输入微信号直 接添加蓝友官方微信好友
				</p>
				<div class="wechtabtn">
					<p class="wecht-btn text-theme text-df text-bold pointer" @click="look = true">点击查看微信号</p>
					<p class="wecht-btn text-theme text-df text-bold pointer" v-if="look">{{weixin}}</p>
				</div>
			</div>
			<div class="edit bg-white" @click.stop="gocenter(1)">
				<p class="text-lg">
					客服电话：<span>400-010-8888</span>
				</p>
				<p class="edit-btn text-theme text-df text-bold pointer">修改我的招工</p> <!-- 跳转到我的招工页面 -->
			</div>
			<p class="text-white text-df flex align-center justify-center margin-top-sm pointer" @click.stop="gocenter(2)"><img src="../../assets/img/whiteyou.png" >常见问题解答</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				weixin:'',
				look:false,//是否展示微信号
			};
		},
		created() {
			this.look = false
			this.getweichat()
		},
		methods: {
			//关闭入群弹窗
			closegroup(){
				this.$emit('closepop')
			},
			gocenter(type){
				this.closegroup()
				this.$emit('gocenter',type)
				
			},
			getweichat(){
				this.ajax('get', '/api/pc/system/getwordsewm', {}, res => {
					if(res.status == 200){
						this.weixin = res.data.weixin
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.llogin {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6600);
		z-index: 999999;
	}
	.login {
		width: 607px;
		height: 633px;
		background: #09827B;
		position: absolute;
		top: 50%;
		left: 50%;
		border-radius: 20px;
		transform: translate(-50%, -50%);
		.icon{
			font-size: 32px;
		}
		.add{
			width: 527px;
			height: 282px;
			background: #FEFDFD;
			border-radius: 20px;
			margin: 0 auto;
			padding: 46px 58px 30px;
			.wechtabtn{
				margin: 35px auto 0;
			}
			.wecht-btn{
				width: 376px;
				height: 43px;
				line-height: 43px;
				border: 1px solid #07706A;
				border-radius: 27px;
				margin: 0 auto 15px;
				// margin-bottom: 15px;
			}
		}
		
		.edit{
			width: 527px;
			height: 178px;
			border-radius: 20px;
			margin: 30px auto 0;
			padding: 46px 0 30px;
			.edit-btn{
				width: 376px;
				height: 53px;
				line-height: 53px;
				border: 1px solid #07706A;
				border-radius: 27px;
				margin: 29px auto 0;
			}
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/public/group.vue